import React, { useState, useEffect } from 'react';
import * as FiltersUI from "air-wp-sync-ui/library/components/form/filters";
const FiltersUIComponent = FiltersUI.default;

export const FilterPropsOperators = {
    GreaterThan: '>',
    Is: '=',
    IsNot: '!=',
    GreaterOrEqualThan: '>=',
    LesserThan: '<',
    LesserOrEqualThan: '<=',
    Contains: 'contains',
    DoesNotContain: 'doesNotContain',
    IsEmpty: 'isEmpty',
    IsNotEmpty: 'isNotEmpty',
    IsWithin: 'isWithin',
    IsAnyOf: 'isAnyOf',
    IsNoneOf: 'isNoneOf',
    HasAnyOf: '|',
    HasAllOf: '&',
    Filename: 'filename',
    Filetype: 'filetype',
};
export default function Filters({ initFiltersValue, ...props }) {
    const [{ conjunction, filters }, setFilterValues] = useState(initFiltersValue);

    useEffect(() => {
        const event = new CustomEvent('airwpsync/filters-updated', { detail: { conjunction, filters } } );
        document.dispatchEvent(event);
    }, [ conjunction, filters ]);

    return <FiltersUIComponent
        { ...props }
        onChange={ (newFiltersValue) => {
            setFilterValues(newFiltersValue);
        } }
        conjunction={ conjunction }
        filters={ filters }
    />;
}
